import { useFieldArray, useFormContext } from 'react-hook-form';
import { Box, Divider, IconButton } from '@hopskipdrive/react-components';
import CloseIcon from '@mui/icons-material/Close';

import { emptyContact, RiderFormValues } from '../../types';

import { AddContactButton } from './AddContactButton';
import { ContactRow } from './ContactRow';

export const ContactsSection = () => {
  const { control } = useFormContext<RiderFormValues>();
  const { fields, append, remove } = useFieldArray<RiderFormValues, 'contacts', 'rhfKey'>({
    control,
    name: 'contacts',
    keyName: 'rhfKey',
  });

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '21px' }}>
      {fields.map((field, index) => (
        <Box key={field.rhfKey} sx={{ display: 'flex', flexDirection: 'column', gap: '21px' }}>
          {index > 0 && <Divider />}
          <Box sx={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
            <Box sx={{ flex: 1, minWidth: 0 }}>
              <ContactRow index={index} />
            </Box>
            {index > 0 && (
              <IconButton
                size="small"
                onClick={() => remove(index)}
                aria-label={`Remove contact ${index + 1}`}
                data-testid={`remove-contact-${index}`}
              >
                <CloseIcon fontSize="small" />
              </IconButton>
            )}
          </Box>
        </Box>
      ))}
      {fields.length < 5 && (
        <Box>
          <AddContactButton onClick={() => append(emptyContact())} />
        </Box>
      )}
    </Box>
  );
};
